import { getKeyFromIds, initialKeyState } from './reducer'

/**
 * @returns {() => initialKeyState}
 */
export function dashboardByIds(accountId, projectId, moduleName) {
  const key = getKeyFromIds(accountId, projectId, moduleName)
  return state => state.dashboard[key] ?? initialKeyState
}
